<app-top-panel 
    [selectedTool]="selectedTool" 
    (toolClick)="toolClick($event)"
    (changeScale)="changeScale($event)"
    (save)="onSave($event)"
    (send)="onSend($event)">
</app-top-panel>
<div fxLayout="row wrap">
    <app-left-panel
        (onSelectFile)="onFileSelected($event)"
        [fxFlex]="leftPanelSize" 
        [ngClass]="leftPanelClass"
        style="background: rgb(86, 86, 84);">
    </app-left-panel>
    <div fxFlex="1.4" fxLayoutAlign="center start">
        <button 
            pButton 
            fxFlex="93" 
            type="button" 
            [ngStyle]="getButtonStyle()"
            (click)="changeLeftPanelVisibility()"
            class="editor-button">
            <fa-icon [icon]="leftPanelIcon" size="0.3x"></fa-icon>
        </button>
    </div>
    <div [fxFlex]="workareaSize">
        <app-svg-editor 
            (imageLoaded)="onImageLoaded($event)"
            [toolEvent]="toolEvent"
            [selectFile]="selectedFile"
            [rowSelection]="rowSelection"
            (undoDelete)="onUndoDelete($event)"
            (undoCreate)="onUndoCreate($event)"
            (undoResizeMove)="onUndoResizeMove($event)"
            (undoAssignDict)="onUndoAssignDict($event)"
            (redoCreate)="onRedoCreate($event)"
            (redoResizeMove)="onRedoResizeMove($event)"
            (redoAssignDict)="onRedoAssignDict($event)"
            (selectionChanged)="onPolygonSelection($event)"
            (deleteElements)="onDeleteElements($event)"
            (polygonAdded)="onDrawPolygon($event)"
            (polygonResized)="onResizePolygon($event)"
            (rectAdded)="onDrawRect($event)"
            (selectedTool)="updateSelectedTool($event)"
            [hidden]="!imageLoaded">
        </app-svg-editor>
        <div *ngIf="!imageLoaded">
            <span class="text-loading" style="margin-left: 20%; margin-top: -5%"> Caricamento planimetria</span>
            <div class="spinner" style="margin-top: 15rem; text-align: center; position: relative; margin-left: 46% !important;">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
        </div>
    </div>
    <app-right-panel 
        [imageChanged]="selectedFile"
        [onDeleteElements]="deleteElements"
        [undoDelete]="undoDelete"
        [undoCreate]="undoCreate"
        [undoResizeMove]="undoResizeMove"
        [undoAssignDict]="undoAssignDict"
        [redoCreate]="redoCreate"
        [redoResizeMove]="redoResizeMove"
        [redoAssignDict]="redoAssignDict"
        [changeScale]="scaleEvent"
        [savePlan]="savePlan"
        [sendPlan]="sendPlan"
        [updatePrintData]="updatePrintData"
        [onPolygonSelection]="polygonSelection"
        [onDrawPolygon]="drawPolygon"
        [onResizePolygon]="resizePolygon"
        [onDrawRect]="drawRect"
        (onRowSelection)="onRowSelection($event)"
        [fxFlex]="rightPanelSize" 
        style="background: rgb(86, 86, 84);">
    </app-right-panel>
</div>